import { Box } from "@mui/material";
import React from "react";

type Props = {
  children?: React.ReactNode;
  // index: any;
  value: any;
  padding: string;
  classes?: any;
  id: string;
};

const TabPanel = ({ children, value, id, padding, classes, ...other }: Props) => (
  <div
    className={classes}
    role="tabpanel"
    hidden={value !== id}
    // id={`simple-tabpanel-${index}`}
    id={id}
    aria-labelledby={`simple-tab-${id}`}
    {...other}
  >
    {value === id ? (
      <Box p={padding}>
        <Box>{children}</Box>
      </Box>
    ) : null}
  </div>
);

export default TabPanel;
